import ExtendedError from "./ExtendedError";

class UserError extends ExtendedError {
  constructor(message, metadata) {
    super(message, { ...metadata, isUserError: true });
  }
}

export default UserError;
